import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from '../../shared/services/auth.service';
import { SidenavService } from '../../shared/services/sidenav.service';
import { LanguageService } from '../../shared/services/language.service';
import { UsersManagementService } from '../../shared/services/usersManagement.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { ManageTechsDialogComponent } from '../manage-techs-dialog/manage-techs-dialog.component';
import { TechnologiesManagementService } from '../../shared/services/technologiesManagement.service';
import { ManageToolsDialogComponent } from '../manage-tools-dialog/manage-tools-dialog.component';
import { RemoveDialogComponent } from '../../backoffice/remove-dialog/remove-dialog.component';
import { TecnologiasService } from '../../shared/services/tecnologias.service';
import { ScrollControlService } from '../../shared/services/scroll-control.service';
import { catchError, debounceTime, delay, retryWhen, scan } from 'rxjs/operators';
import { Subject, throwError } from 'rxjs';
import { InfoBarWithStatusService } from '../../shared/services/info-bar-with-status.service';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
  standalone: false,
  selector: 'app-techs-tools-management',
  templateUrl: './techs-tools-management.component.html',
  styleUrls: ['./techs-tools-management.component.css'],
  animations: [
    trigger('slideToggleHorizontal', [
      transition(':enter', [
        style({ width: '0px', opacity: 0, overflow: 'hidden' }),
        animate('300ms ease-out', style({ width: '*', opacity: 1 })),
      ]),
    ]),
  ]
})
export class TechsToolsManagementComponent implements OnInit {
  variables: any;
  isOpen: boolean = false;
  shouldPinSidenav: boolean = false;
  colorWhite = '#fff';
  allTechnologies: any = [];
  allTools: any = [];
  currentTech: any = { id: '', name: '' };
  subForm: any;
  isActionsListVisible: boolean = false;
  listFilteredItem: any = [];
  currentSelected: any = '';
  newlyAddedTech: any = '';
  currentElement: any;
  index: any = 0;
  presentedTecs: any = [];
  presTecs: any = [];
  cantEdit: string = '';

  errorDetected: boolean = false;
  errorText: string = '';
  isAllLodaing: boolean = true;
  isLoadingtechs: boolean = true;
  isLoadingtools: boolean = false;

  errorMessages: any;
  errorMessagesTechById: any;
  errorMessageAllTechs: any;

  searchTerm: string = '';

  searchSubject = new Subject<string>();

  // talvez fazer algo tipo quando '' só vai a db se uma bool dizer que já tinha sido filtrado  aalgodo genero seila


  constructor(
    public authService: AuthService,
    private sidenavService: SidenavService,
    private languageService: LanguageService,
    public dialog: MatDialog,
    private router: Router,
    private _formBuilder: FormBuilder,
    private UsersManagementService: UsersManagementService,
    private tecnologiasService: TecnologiasService,
    private infoBar: InfoBarWithStatusService,
    private TechnologiesManagementService: TechnologiesManagementService,
    private scrollService: ScrollControlService
  ) { }

  ngOnInit(): void {
    this.scrollService.setScroll(true);

    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;
      this.cantEdit = this.variables.cantEdit;
      this.errorMessages = {
        "Only SUPER-ADMIN or ADMIN can remove a tool.": this.variables.onlySuperAdminOrAdminCanRemoveTool,
        "Tool name is required for removal.": this.variables.toolNameRequiredForRemoval,
        "Technology not found": this.variables.technology + this.variables.notFound,
        "No tools found for this technology.": this.variables.noToolsFoundForTechnology,
        "Tool not found in technology.": this.variables.toolNotFoundInTechnology,
        "Access denied.": this.variables.notAuthorized,
      };
      this.errorMessagesTechById = {
        "Technology not found": this.variables.technology + this.variables.notFound,
        "Access denied.": this.variables.notAuthorized,
        'Invalid JWT token': this.variables.sessionExpired,
      };
      this.errorMessageAllTechs = {
        "Access denied.": this.variables.notAuthorized,
        'Invalid JWT token': this.variables.sessionExpired,
      };
    });

    this.getAllTechs();

    this.subForm = this._formBuilder.group({
      projectType: [''],
    });

    this.searchSubject.pipe(debounceTime(1000)).subscribe((searchTerm) => {
      this.searchFilter(searchTerm);
    });
  }

  getAllTechs() {
    this.isAllLodaing = true;

    this.TechnologiesManagementService.getAllTechnologies().pipe(
      retryWhen(errors =>
        errors.pipe(
          scan((retryCount, error) => {
            if (retryCount >= 3) {
              throw error;
            }
            return retryCount + 1;
          }, 0),
          delay(2500)
        )
      ),
      catchError(err => {
        console.error('Error:', err);

        this.errorDetected = true;
        const message = this.errorMessageAllTechs[err.error.message]
        this.errorText = message ? message : this.variables.detectedError;

        return throwError(() => err);
      })
    ).subscribe({
      next: (data: any[]) => {
        try {
          this.allTechnologies = data;
          this.presTecs = data

          if (this.searchTerm.trim() !== '') {
            this.searchFilter(this.searchTerm);
          }
        }
        catch (err) {
          console.error('Error:', err);

          this.errorDetected = true;
          this.errorText = this.variables.detectedError;
        }
      },
      complete: () => {
        if (this.allTechnologies && !this.errorDetected) {
          this.isAllLodaing = false;
        }
      }
    });
  }

  getTechById(id: string) {
    this.isLoadingtools = true;
    this.isActionsListVisible = false;

    this.TechnologiesManagementService.getTechnologyById(id).pipe(
      retryWhen(errors =>
        errors.pipe(
          scan((retryCount, error) => {
            if (retryCount >= 3) {
              throw error;
            }
            return retryCount + 1;
          }, 0),
          delay(2500)
        )
      ),
      catchError(err => {
        console.error('Error: ', err);

        this.errorDetected = true;
        this.errorText = this.variables.detectedError;
        const message = this.errorMessagesTechById[err.error.message]
        this.errorText = message ? message : this.variables.detectedError;

        return throwError(() => err);
      })
    ).subscribe({
      next: (data: any) => {
        try {
          this.allTools = data.tools;
          this.currentTech = data;
        } catch (err) {
          console.error('Error:', err);

          this.errorDetected = true;
          this.errorText = this.variables.detectedError;
        }
      },
      complete: () => {
        if (this.allTools && this.currentTech) {
          this.isLoadingtools = false;
          this.isActionsListVisible = true;
        }
      }
    });
  }


  ngAfterContentChecked() {
    if (this.currentElement == null) {
      /*if(this.allTechnologies.length>0) {
        this.showToolsList(this.allTechnologies[this.index].name);
      }*/
    }
  }

  onSidenavToggle() {
    this.isOpen = !this.isOpen;
    this.sidenavService.sideNavState$.next(this.isOpen);
  }

  onCheckboxChange(event: any) {
    this.shouldPinSidenav = event;
    this.sidenavService.shouldPinSidenavState.next(this.shouldPinSidenav);
  }

  onSearchChange(event: any) {
    this.searchTerm = event.target.value;
    this.searchSubject.next(this.searchTerm);
  }

  searchFilter(searchTerm: string) {
    if (searchTerm) {
      this.presTecs = this.allTechnologies.filter((tech: any) =>
        tech.name.trim().toLowerCase().includes(searchTerm.trim().toLowerCase())
      );
    } else {
      this.presTecs = this.allTechnologies;
    }
  }


  addNewTech() {
    const data = {
      title: this.variables.addNewTechnology,
      edit: false,
      allTechs: this.allTechnologies
    }

    let dialogRef = this.dialog.open(ManageTechsDialogComponent, {
      data: data
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result.data.success) {
        this.newlyAddedTech = result.data.newTech
        this.getAllTechs();
      }
    })
  }

  removeTech(techId: string) {
    let dialogRef = this.dialog.open(RemoveDialogComponent);

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.TechnologiesManagementService.removeTechnology(techId).subscribe
          ({
            next: (data) => {

              if (data) {
                this.currentTech = { id: '', name: '' };
                this.newlyAddedTech = '';
                this.currentSelected = '';
                this.allTools = [];
                this.isActionsListVisible = false;

                this.allTechnologies = this.allTechnologies.filter((tech: any) => tech.id !== techId);
                this.presTecs = this.presTecs.filter((tech: any) => tech.id !== techId);
                if (this.searchTerm.trim() !== '') {
                  this.searchFilter(this.searchTerm);
                }
                this.getAllTechs();
              }
            },
            error: (error) => {
              console.error('Error:', error.error);
            }
          })
      }
    })
  }
  

  editTech(techId: string, techName: string, techActive: boolean) {
    const data = {
      title: this.variables.editTechnology,
      edit: true,
      tecId: techId,
      tecName: techName,
      tecActive: techActive,
    }

    let dialogRef = this.dialog.open(ManageTechsDialogComponent, {
      data: data
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result.data) {
        this.getAllTechs();
      }

    })
  }

  editTool(tool: any) {
    const data = {
      title: this.variables.editTool,
      edit: true,
      tecName: this.currentTech.name,
      techId: this.currentTech.id,
      toolName: tool.name,
      productivity: tool.productivity,
    }

    let dialogRef = this.dialog.open(ManageToolsDialogComponent, {
      data: data
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result.data.success) {
        this.infoBar.showSnackbar(this.variables.toolUpdated, ['successful-snackbar'], 3000);
        this.getTechById(this.currentTech.id);
      }
    })
  }

  removeTool(toolName: string) {
    let dialogRef = this.dialog.open(RemoveDialogComponent);

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.TechnologiesManagementService.removeToolFromTechnology(this.currentTech.id, toolName).subscribe
          ({
            next: (data) => {

              if (data) {
                this.infoBar.showSnackbar(this.variables.toolRemovedFromTechnology, ['successful-snackbar'], 4000);
                this.getTechById(this.currentTech.id);
              }
            },
            error: (error) => {
              console.error('Error:', error.error);
            }
          })
      }
    })

  }

  addNewTool() {

    const data = {
      title: this.variables.addNewTool,
      techId: this.currentTech.id,
      tecName: this.currentTech.name,
      edit: false,
    }

    let dialogRef = this.dialog.open(ManageToolsDialogComponent, {
      data: data
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result.data.success) {
        this.infoBar.showSnackbar(this.variables.toolAddedToTechnology, ['successful-snackbar'], 4000);
        this.getTechById(this.currentTech.id);
      }
    });
  }

  showToolsList(tecId: string) {
    if (this.currentSelected === tecId && this.isActionsListVisible) {
      this.isActionsListVisible = false;
      this.currentSelected = '';
      return;
    }
    this.currentSelected = tecId;
    this.getTechById(tecId);
  }


}
